import React, { useState } from 'react';
import { Button, DatePicker } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectViewMode,
  selectViewType,
  setTimelineFocusDate,
} from '../../redux/store/ui/common';
import { ViewMode } from '../../hooks/viewMode';
import { ViewType } from '../../hooks/useViewType';
import { ANT_PICKERS_FORMAT } from '../../utils/formatDate';
import {
  DAYS_AFTER_TODAY,
  DAYS_BEFORE_TODAY,
} from '../VehicleTimeline/constants';

const toIsoDate = (d: Dayjs): string => d.format('YYYY-MM-DD');

const TimelineDateControls: React.FC = () => {
  const dispatch = useDispatch();
  const viewMode = useSelector(selectViewMode);
  const viewType = useSelector(selectViewType);
  // Controlled so the "Today" button can clear the picker's displayed value.
  const [picked, setPicked] = useState<Dayjs | null>(null);

  const isActive =
    viewMode === ViewMode.VEHICLE && viewType === ViewType.TIME_TABLE;

  if (!isActive) return null;

  const handleToday = () => {
    setPicked(null); // clear the Jump-to-date picker
    dispatch(setTimelineFocusDate(toIsoDate(dayjs())));
  };

  const handlePick = (value: Dayjs | null) => {
    setPicked(value);
    if (!value) return;
    dispatch(setTimelineFocusDate(toIsoDate(value)));
  };

  // Only allow jumping within the rendered range (today − DAYS_BEFORE_TODAY …
  // today + DAYS_AFTER_TODAY) — dates outside it have no columns to scroll to.
  const minDate = dayjs().startOf('day').subtract(DAYS_BEFORE_TODAY, 'day');
  const maxDate = dayjs().startOf('day').add(DAYS_AFTER_TODAY, 'day');
  const disabledDate = (current: Dayjs): boolean =>
    !!current && (current.isBefore(minDate) || current.isAfter(maxDate));

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginLeft: 12,
      }}
    >
      <DatePicker
        size="small"
        format={ANT_PICKERS_FORMAT}
        placeholder="Jump to date"
        value={picked}
        onChange={handlePick}
        disabledDate={disabledDate}
        allowClear
      />
      <Button size="small" onClick={handleToday}>
        Today
      </Button>
    </div>
  );
};

export default TimelineDateControls;
